// Labels of the "Send to App" preview / confirmation modal.
const TEXT = {
  ar: {
    title: "معاينة الإرسال إلى التطبيق",
    description: "راجع الرسالة والملف المرفق لكل تطبيق. لن يُرسل شيء قبل تأكيدك.",
    loading: "جاري تجهيز الرسالة والملف…",
    loadFailed: "تعذّر تجهيز الرسالة",
    retry: "إعادة المحاولة",
    apps: "التطبيقات المختارة",
    recipients: "التطبيقات والمستلمون",
    tabs: "التطبيقات",
    items: (n) => (n === 1 ? "صنف واحد" : n === 2 ? "صنفان" : n >= 3 && n <= 10 ? `${n} أصناف` : `${n} صنفاً`),
    action: { add: "إضافة", update: "تحديث", delete: "حذف" },
    attachment: "الملف المرفق",
    download: "تنزيل الملف",
    previewFile: "معاينة محتوى الملف",
    hideFile: "إخفاء المعاينة",
    columns: { section: "القسم", item: "الصنف", price: "السعر", additions: "الإضافات" },
    moreRows: (n) => `و${n} صنفاً آخر في الملف`,
    problemTitle: "لا يمكن الإرسال لهذا التطبيق",
    sendNow: "إرسال الآن",
    saveDraft: "حفظ كمسودة",
    cancel: "إلغاء",
    close: "إغلاق",
    working: "جاري التنفيذ…",
    draftSaved: (n) => (n === 1 ? "تم حفظ المسودة في الطلبات. لم يُرسل شيء." : `تم حفظ ${n} مسودات في الطلبات. لم يُرسل شيء.`),
    draftExisting: "يوجد طلب مفتوح بنفس المحتوى لبعض التطبيقات؛ لم يُنشأ تكرار.",
    confirmTitle: "تأكيد الإرسال",
    confirmText: "سيتم إرسال بريد إلكتروني إلى كل تطبيق مذكور أدناه. تأكد من التطبيق والمستلمين والمرفقات.",
    confirmSend: "تأكيد الإرسال",
    confirmBack: "إلغاء (تبقى المسودة)",
    confirmApp: "التطبيق",
    confirmTo: "إلى",
    confirmCc: "نسخة",
    confirmFiles: "المرفقات",
    confirmItems: "الأصناف",
    resultTitle: "نتيجة الإرسال",
    sentOne: "قبِل مزوّد البريد الرسالة.",
    failedOne: "لم تُرسل الرسالة. الطلب محفوظ في الطلبات مع الخطأ ويمكنك إعادة المحاولة من هناك.",
    notSentOne: "الطلب محفوظ كمسودة في الطلبات.",
    allSent: "تم إرسال جميع الرسائل.",
    someFailed: "لم تُرسل بعض الرسائل؛ طلباتها محفوظة في الطلبات.",
    reference: "المرجع",
    errors: {
      DRAFT_CHANGED: "تغيّرت الرسالة منذ المعاينة. افتح الطلب من الطلبات وراجعه من جديد.",
      REQUEST_BUSY: "الطلب قيد الإرسال أو أُرسل أو أُلغي بالفعل.",
      EMAIL_ALREADY_SENT: "أُرسلت هذه الرسالة من قبل.",
      REQUEST_NOT_ELIGIBLE: "لا يمكن إرسال هذا الطلب (ليس مسودة).",
      EMAIL_ACCESS_DENIED: "ليس لديك صلاحية إرسال هذه الرسالة.",
      NETWORK: "تعذّر الاتصال بالخادم.",
    },
  },
  en: {
    title: "Preview Send to App",
    description: "Review the email and attached file for each app. Nothing is sent before you confirm.",
    loading: "Preparing the email and file…",
    loadFailed: "Could not prepare the email",
    retry: "Retry",
    apps: "Selected apps",
    recipients: "Apps and recipients",
    tabs: "Apps",
    items: (n) => `${n} ${n === 1 ? "item" : "items"}`,
    action: { add: "Add", update: "Update", delete: "Delete" },
    attachment: "Attached file",
    download: "Download file",
    previewFile: "Preview file content",
    hideFile: "Hide preview",
    columns: { section: "Section", item: "Item", price: "Price", additions: "Additions" },
    moreRows: (n) => `and ${n} more ${n === 1 ? "item" : "items"} in the file`,
    problemTitle: "This app cannot be sent to",
    sendNow: "Send Now",
    saveDraft: "Save as Draft",
    cancel: "Cancel",
    close: "Close",
    working: "Working…",
    draftSaved: (n) => (n === 1 ? "Draft saved in Requests. Nothing was sent." : `${n} drafts saved in Requests. Nothing was sent.`),
    draftExisting: "An open request with the same content already exists for some apps; no duplicate was created.",
    confirmTitle: "Confirm sending",
    confirmText: "An email will be sent to each app listed below. Check the app, the recipients and the attachments.",
    confirmSend: "Confirm and send",
    confirmBack: "Cancel (draft is kept)",
    confirmApp: "App",
    confirmTo: "To",
    confirmCc: "Cc",
    confirmFiles: "Attachments",
    confirmItems: "Items",
    resultTitle: "Send result",
    sentOne: "The mail provider accepted the email.",
    failedOne: "The email was not sent. The request is kept in Requests with the error; retry it from there.",
    notSentOne: "The request is kept as a draft in Requests.",
    allSent: "All emails were sent.",
    someFailed: "Some emails were not sent; their requests are kept in Requests.",
    reference: "Reference",
    errors: {
      DRAFT_CHANGED: "The email changed since the preview. Open the request in Requests and review it again.",
      REQUEST_BUSY: "The request is being sent, or was already sent or canceled.",
      EMAIL_ALREADY_SENT: "This email was already sent.",
      REQUEST_NOT_ELIGIBLE: "This request cannot be sent (it is not a draft).",
      EMAIL_ACCESS_DENIED: "You are not allowed to send this email.",
      NETWORK: "Could not reach the server.",
    },
  },
};

export const sendToAppPreviewText = (lang) => TEXT[lang] || TEXT.ar;
